import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { getPaginatedData } from 'affiny-core/modules/helpers/pagination';
import {
  selectCurrentPage,
  selectPhotoRequestMessageId,
  selectTotalItem,
} from 'affiny-core/redux/selectors/photoRequestsSelectors';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import {
  getPhotoRequests,
  postPhotoRequest,
} from '../api/repositories/photoPrivacy/photoRequests';
import { postPhotoReveal } from '../api/repositories/photoPrivacy/photoReveals/photoReveals.sagas';
import { getCountersSaga } from '../counters/saga';
import { ActionsOfType } from '../helpers';
import { checkHasCompletedProfile } from '../helpers/checkSaga';
import {
  EPhotoRequestsActionType,
  photoRequestsAction,
  TPhotoRequestsAction,
} from './actions';

export function* getPhotoRequestsSaga(
  action: ActionsOfType<TPhotoRequestsAction, EPhotoRequestsActionType.GET>
) {
  if (!(yield* checkHasCompletedProfile())) return;

  yield call(getPaginatedData, {
    pageSelector: selectCurrentPage,
    totalSelector: selectTotalItem,
    reset: action.payload.reset,
    apiCall: getPhotoRequests,
    resetAction: photoRequestsAction.resetPhotoRequests,
    successAction: photoRequestsAction.getPhotoRequestsSuccess,
  } as any);
}

export function* postPhotoRequestSaga(
  action: ActionsOfType<TPhotoRequestsAction, EPhotoRequestsActionType.POST>
) {
  if (!(yield* checkHasCompletedProfile())) return;

  const { receiverId } = action.payload;

  yield call(postPhotoRequest, receiverId);
  yield put(photoRequestsAction.postPhotoRequestSuccess({ receiverId }));
}

export function* answerPhotoRequestSaga(
  action: ActionsOfType<
    TPhotoRequestsAction,
    EPhotoRequestsActionType.ANSWER_PHOTO_REQUEST
  >
) {
  if (!(yield* checkHasCompletedProfile())) return;

  const { isPhotoRequestAccepted, receiverId } = action.payload;
  const messageId = yield select(selectPhotoRequestMessageId, receiverId);

  // We need to call a resource from photoReveal because to accept a photoRequest, you need to post on photoReveal
  yield call(postPhotoReveal, {
    receiverId,
    messageId,
    isPhotoRequestAccepted,
  });
  yield put(
    photoRequestsAction.answerPhotoRequestSuccess({
      idToRemove: receiverId,
    })
  );
  yield call(getCountersSaga);
}

export function* photoRequestsRootSaga() {
  yield all([
    takeLatest(
      EPhotoRequestsActionType.GET,
      handleAsyncStatus(getPhotoRequestsSaga, EAsyncEventTypes.PHOTO_REQUESTS)
    ),
    takeLatest(
      EPhotoRequestsActionType.ANSWER_PHOTO_REQUEST,
      handleAsyncStatus(
        answerPhotoRequestSaga,
        EAsyncEventTypes.ANSWER_PHOTO_REQUEST
      )
    ),
    takeLatest(
      EPhotoRequestsActionType.POST,
      handleAsyncStatus(
        postPhotoRequestSaga,
        EAsyncEventTypes.POST_PHOTO_REQUEST
      )
    ),
  ]);
}
